import React, { useState } from "react";
import { Row, Col, Input, FormGroup, Button } from "reactstrap";
import Form from "./Form";
import Select from "react-select";
import Flatpickr from "react-flatpickr";

const Search = ({
  data,
  setData,
  fetchData,
  searchQuery,
  setSearchQuery,
  dateRange,
  setDateRange,
  fileType,
  setFileType,
}) => {
  const [isFormVisible, setIsFormVisible] = useState(false);

  const toggleForm = () => {
    setIsFormVisible(!isFormVisible);
  };

  return (
    <div>
      <Row>
        <Row>
          <Col lg={6}>
            <h5 className="pt-2">Documents</h5>
          </Col>
          <Col className="mb-2 text-end" lg={6}>
            <Button className="btn-success" onClick={toggleForm}>
              <i className="bx bx-plus-medical fs-10  "></i> Upload New
              documents
            </Button>
          </Col>
        </Row>
        {!isFormVisible && (
          <Col lg={3}>
            <div className="search-box ">
              <input
                type="text"
                className="form-control search"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
        )}

        {!isFormVisible && (
          <Col lg={3}>
            <div className="">
              <Flatpickr
                className="form-control"
                id="datepicker-publish-input"
                placeholder="Select a range of date"
                options={{
                  altInput: true,
                  altFormat: "Y-m-d", // Display format in the input field
                  mode: "range",
                  dateFormat: "Y-m-d", // Internal format used by Flatpickr
                }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
              />
            </div>
          </Col>
        )}
        {!isFormVisible && (
          <Col lg={3}>
            <FormGroup>
              <Select
                isClearable={true}
                placeholder="Choose file type"
                options={[
                  { value: 8, label: "Star" },
                  { value: 3, label: "String" },
                  { value: 1, label: "Pdf" },
                  { value: 2, label: "Excel" },
                ]}
                value={fileType}
                onChange={setFileType}
              />
            </FormGroup>
          </Col>
        )}
      </Row>

      {isFormVisible && (
        <Form
          onClose={toggleForm}
          data={data}
          setData={setData}
          fetchData={fetchData}
        />
      )}
    </div>
  );
};

export default Search;
